import React, { useState } from "react";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { useCustomClaims } from "hooks";
import { useAppContext } from "store/context";
import Splash from "components/Splash";
import LoadingSpinner from "components/LoadingSpinner";
import OrdersHistory from "./components/OrdersHistory";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

const OrdersHistoryContainer = ({ authed }) => {
  const { firebase, user } = useAppContext();
  const {
    claims: { merchant_id },
  } = useCustomClaims(user);
  const [selectedDate, handleDateChange] = useState(moment());

  const [orders, loading] = useCollectionData(
    firebase
      .firestore()
      .collection(`orders_${merchant_id}`)
      .where("created_at", ">=", selectedDate.startOf("day").toISOString())
      .where("created_at", "<=", selectedDate.endOf("day").toISOString())
  );

  if (!authed) {
    return <Splash />;
  }

  if (loading || orders == null) {
    return <LoadingSpinner />;
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <OrdersHistory
        orders={orders.filter((x) => x.completed_at)}
        selectedDate={selectedDate}
        onDateChange={handleDateChange}
      />
    </MuiPickersUtilsProvider>
  );
};

export default OrdersHistoryContainer;
